import { isFinite } from 'lodash';

const parseInteger = (value) => {
  return !isFinite(parseInt(value)) ? value : parseInt(value);
};

export default parseInteger;
